export var noop = function noop() {};
export var isBrowser = typeof window !== 'undefined' && typeof navigator !== 'undefined' && typeof document !== 'undefined';
export var truthyAndArrayPredicate = function truthyAndArrayPredicate(conditions) {
  return conditions.every(function (i) {
    return Boolean(i);
  });
};
export var truthyOrArrayPredicate = function truthyOrArrayPredicate(conditions) {
  return conditions.some(function (i) {
    return Boolean(i);
  });
};